<template>
  <div class="accordion-item">
    <h2 class="justify-items-around accordion-header">
      <button
        type="button"
        :aria-expanded="isOpen"
        class="accordion-button"
        :class="{ 'collapsed': !isOpen }"
      >
        <div class="form-check form-switch" @click="toggleAccordion">
          <input
            type="checkbox"
            id="pathology-edema-switch"
            class="form-check-input"
            :checked="isOpen"
          />
          <label title  class="form-check-label" >
              <slot name="title">
                  title
              </slot>
          </label>
        </div>
        <template v-if="isOpen">
          <span style="margin-left: 1em;">
            <slot name="img"></slot>
          </span>
        </template> 
      </button>
    </h2>
    <div
      v-if="!nolist"
      class="accordion-collapse2 "
      :class="{ show: isOpen }"
      ref="collapse"
    >
      <div class="accordion-body">
        <div class="mb-3">
           <slot>
            abc
           </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accordion-item",
  props: {
    nolist: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen  = !this.isOpen;
      this.$emit('toggle', this.isOpen);
    } 
  },
};
</script>

<style scoped="scoped" lang="less">
.accordion-collapse2 {

  max-height: 0;
  position: relative;
  overflow: hidden;
  transition:  0.3s linear
  
}

.accordion-collapse2.show {
  
  max-height: 200px;
}

.accordion-button{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
